import Index from "../views/mengw/Index.vue";
import Find from "../views/mengw/Find/Find.vue";
import Login from "../views/mengw/Login/Login.vue";
import Register from "../views/mengw/Register/Register.vue";
import ForumDetail from "../views/mengw/ForumDetail/ForumDetail.vue";

const routes = [
    {
        path: "/index",
        name: "index",
        component: Index,
    },
    {
        path: "/circle/:id",
        name: "circle",
        component: () => import("../views/mengw/Index.vue"),
    },
    {
        path: "/demo", // demo
        name: "demo",
        component: () => import("../views/mengw/Demo/Demo.vue"),
    },
    {
        path: "/find",
        name: "find",
        component: Find,
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            title: "登录",
        }
    },
    {
        path: "/register",
        name: "register",
        component: () => import("../views/mengw/Register/Register.vue"),
        meta: {
            title: "注册",
        }
    },
    {
        path: "/customercenter",
        name: "customercenter",
        component: () =>
            import(
                "../views/mengw/CustomerCenter/CustomerCenter.vue"
            ),
    },
    {
        path: "/forget",
        name: "forget",
        component: () => import("../views/mengw/Forget/Forget.vue"),
        meta: {
            title: "密码重置",
        }
    },
    {
        path: "/changepassword",
        name: "changepassword",
        component: () =>
            import(
                "../views/mengw/ChangePassword/ChangePassword.vue"
            ),
    },
    {
        path: "/editForum/:type/:id",
        name: "editForum",
        component: () =>
            import("../views/mengw/EditForum/EditForum.vue"),
    },
    {
        path: "/forumdetail/:id",
        name: "forumdetail",
        component: ForumDetail,
    },
    {
        path: "/commentedit/:type/:id",
        name: "commentedit",
        component: () =>
            import("../views/mengw/CommentEdit/CommentEdit.vue"),
    },
    {
        path: "/commentlist/:id/:pid",
        name: "commentlist",
        component: () =>
            import("../views/mengw/CommentList/CommentList.vue"),
    },
    {
        path: "/iframeorder",
        name: "iframeorder",
        component: () =>
            import("../views/mengw/IframeOrder/IframeOrder.vue"),
    },
    {
        path: "/gamelist",
        name: "gamelist",
        component: () => import("../views/mengw/GameList/GameList.vue"),
    },
    {
        path: "/gamedetail/:gameid",
        name: "gamedetail",
        component: () =>
            import("../views/mengw/GameDetail/GameDetail.vue"),
    },
    {
        path: "/gameupdatalog/:gameid",
        name: "gameupdatalog",
        component: () =>
            import(
                "../views/mengw/GameUpdataLog/GameUpdataLog.vue"
            ),
    },
    {
        path: "/welfare",
        name: "welfare",
        component: () => import("../views/mengw/Vip/vip.vue"),
    },
    {
        path: "/goodsdetail/:goodsid",
        name: "goodsdetail",
        component: () =>
            import("../views/mengw/GoodsDetail/GoodsDetail.vue"),
    },
    {
        path: "/mine",
        name: "mine",
        component: () => import("../views/mengw/mine/mine.vue"),
    },
    {
        path: "/userinfo",
        name: "userinfo",
        component: () => import("../views/mengw/UserInfo/UserInfo.vue"),
    },
    {
        path: "/treasurechest",
        name: "treasurechest",
        component: () => import("../views/mengw/TreasureChest/TreasureChest.vue"),
    },
    {
        path: "/minerecord",
        name: "minerecord",
        component: () => import("../views/mengw/MineRecord/MineRecord.vue"),
    },
    {
        path: '/minegame',
        name: 'minegame',
        component: () => import('../views/mengw/MineGame/MineGame.vue'),
    },
    {
        path: '/minemember',
        name: 'minemember',
        component: () => import('../views/mengw/MineMember/minemember.vue'),
    },
    {
        path: '/minegift',
        name: 'minegift',
        component: () => import('../views/mengw/MineGift/MineGift.vue'),
    },
    {
        path: '/address',
        name: 'address',
        component: () => import('../views/mengw/Address/Address.vue'),
    },
    {
        path: '/integraldetail',
        name: 'integraldetail',
        component: () => import('../views/mengw/IntegralDetail/IntegralDetail.vue'),
    },
    {
        path: '/drafts',
        name: 'drafts',
        component: () => import('../views/mengw/Drafts/Drafts.vue'),
    },
    {
        path: '/usersafe',
        name: 'usersafe',
        component: () => import('../views/mengw/UserSafe/UserSafe.vue'),
    },
    {
        path: '/paypwd',
        name: 'paypwd',
        component: () => import('../views/mengw/PayPwd/PayPwd.vue'),
    },
    {
        path: '/bindingphone',
        name: 'bindingphone',
        component: () => import('../views/mengw/BindingPhone/BindingPhone.vue'),
    },
    {
        path: '/realname',
        name: 'realname',
        component: () => import('../views/mengw/RealName/RealName.vue'),
        meta: {
            title: "实名认证",
        }
    },
    {
        path: '/switchuser',
        name: 'switchuser',
        component: () => import('../views/mengw/SwitchUser/SwitchUser.vue'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/mengw/About/About.vue'),
    },
    {
        path: '/agreement/:type',
        name: 'agreement',
        component: () => import('../views/mengw/Agreement/Agreement.vue'),
    },
    {
        path: '/message',
        name: 'message',
        component: () => import('../views/mengw/Message/Message.vue'),
    },
    {
        path: '/noticedetail/:id',
        name: 'noticedetail',
        component: () => import('../views/mengw/NoticeDetail/NoticeDetail.vue'),
    },
    {
        path: '/search/:type',
        name: 'search',
        component: () => import('../views/mengw/Search/Search.vue'),
    },
    {
        path: '/complaint/:type/:id',
        name: 'complaint',
        component: () => import('../views/mengw/Complaint/Complaint.vue'),
    },
    {
        path: '/uesrdetail',
        name: 'minedetail',
        component: () => import('../views/mengw/MineDetail/MineDetail.vue'),
    },
    {
        path: '/attention/:tid',
        name: 'attention',
        component: () => import('../views/mengw/Attention/Attention.vue'),
    },
    {
        path: '/mineattention',
        name: 'mineattention',
        component: () => import('../views/mengw/MineAttention/MineAttention.vue'),
    },
    {
        path: '/goodsvirtualdetail/:goodsid',
        name: 'goodsvirtualdetail',
        component: () => import('../views/mengw/GoodsVirtualDetail/GoodsVirtualDetail.vue'),
    },
    {
        path: '/minecollection',
        name: 'minecollection',
        component: () => import('../views/mengw/MineCollection/MineCollection.vue'),
    },
    {
        path: '/headdress',
        name: 'headdress',
        component: () => import('../views/mengw/HeadDress/HeadDress.vue'),
    },
    {
        path: '/userdetail',
        name: 'userdetail',
        component: () => import('../views/mengw/UserDetail/userdetail.vue'),
    },
    {
        path: '/sign/:forum_id/:is_bind_role',
        name: 'sign',
        component: () => import('../views/mengw/Sign/Sign.vue'),
    },
    {
        path: '/',
        name: 'game',
        component: () => import("../views/mengw/Game/Game.vue"),
    },
    {
        path: '/iframe-view',
        name: 'iframe-view',
        component: () => import("../views/mengw/IFrame/IFrame.vue"),
    },
    //type1为购买，type2为续费
    {
        path: '/cloudPhoneShop/:type',
        name: 'cloudPhoneShop',
        component: () => import('../views/mengw/CloudPhoneShop/CloudPhoneShop.vue'),
    },
    {
        path: '/wechatpay/:orderId',
        name: 'wechatpay',
        component: () => import('../views/mengw/WechatPay/WechatPay.vue'),
    },
    {
        path: '/getQrCodeInfo',
        name: 'getQrCodeInfo',
        component: () => import('../views/mengw/GetQrCodeInfo/GetQrCodeInfo.vue'),
    },
    {
        path: '/h5game',
        name: 'h5game',
        component: () => import('../views/mengw/h5game/h5game.vue'),
    },
    {
        path: '/appDownload',
        name: 'appDownload',
        component: () => import('../views/mengw/AppDownload/AppDownload.vue'),
    },
    {
        path: '/replyNews',
        name: 'replyNews',
        component: () => import('../views/mengw/ReplyNews/ReplyNews.vue'),
    },
    {
        path: '/likesNews',
        name: 'likesNews',
        component: () => import('../views/mengw/LikesNews/LikesNews.vue'),
    },
    {
        path: '/officialNewsDetail',
        name: 'officialNewsDetail',
        component: () => import('../views/mengw/OfficialNewsDetail/OfficialNewsDetail.vue'),
    },
    {
        path: '/cloudPurchaseList',
        name: 'cloudPurchaseList',
        component: () => import('../views/mengw/CloudPurchaseList/CloudPurchaseList.vue'),
    },
    {
        path: '/cloudPhoneManage',
        name: 'cloudPhoneManage',
        component: () => import('../views/mengw/CloudPhoneManage/CloudPhoneManage.vue'),
    },
    {
        path: '/superTopic',
        name: 'superTopic',
        component: () => import('../views/mengw/SuperTopic/SuperTopic.vue'),
    },
    {
        path: '/moreSuperTopic',
        name: 'moreSuperTopic',
        component: () => import('../views/mengw/MoreSuperTopic/MoreSuperTopic.vue'),
    },
    {
        path: '/searchPage',
        name: 'searchPage',
        component: () => import('../views/mengw/SearchPage/SearchPage.vue'),
    },
    // sdk页面
    {
        path: '/sdkindex',
        name: 'sdkindex',
        component: () => import('../views/mengw/sdk/index/index.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdksetting',
        name: 'sdksetting',
        component: () => import('../views/mengw/sdk/setting/setting.vue'),
        meta: {
            title: "设置",
        }
    },
    {
        path: '/sdkchangepassword',
        name: 'sdkchangepassword',
        component: () => import('../views/mengw/sdk/changepassword/changepassword.vue'),
        meta: {
            title: "修改密码",
        }
    },
    {
        path: '/sdkfocuswechat',
        name: 'sdkfocuswechat',
        component: () => import('../views/mengw/sdk/focuswechat/focuswechat.vue'),
        meta: {
            title: "关注公众号",
        }
    },
    {
        path: '/sdksharegame',
        name: 'sdksharegame',
        component: () => import('../views/mengw/sdk/sharegame/sharegame.vue'),
        meta: {
            title: "分享游戏",
        }
    },
    {
        path: '/sdkgift',
        name: 'sdkgift',
        component: () => import('../views/mengw/sdk/gift/gift.vue'),
        meta: {
            title: "礼包",
        }
    },
    {
        path: '/sdkrealname',
        name: 'sdkrealname',
        component: () => import('../views/mengw/sdk/realname/realname.vue'),
        meta: {
            title: "实名认证",
        }
    },
    {
        path: '/sdkbindphone',
        name: 'sdkbindphone',
        component: () => import('../views/mengw/sdk/bindphone/bindphone.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdkresetpassword',
        name: 'sdkresetpassword',
        component: () => import('../views/mengw/sdk/resetpassword/resetpassword.vue'),
        meta: {
            title: "重置密码",
        }
    },
    {
        path: '/sdksecurityquestion',
        name: 'sdksecurityquestion',
        component: () => import('../views/mengw/sdk/securityquestion/securityquestion.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdkdeleteaccount',
        name: 'sdkdeleteaccount',
        component: () => import('../views/mengw/sdk/deleteaccount/deleteaccount.vue'),
        meta: {
            title: "账号注销",
        }
    },
    {
        path: '/sdkuseragreement',
        name: 'sdkuseragreement',
        component: () => import('../views/mengw/sdk/useragreement/useragreement.vue'),
        meta: {
            title: "用户协议",
        }
    },
    {
        path: '/sdkprivacypolicy',
        name: 'sdkprivacypolicy',
        component: () => import('../views/mengw/sdk/privacypolicy/privacypolicy.vue'),
        meta: {
            title: "隐私条款",
        }
    },
];

export default routes;
